import React from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {ServerGetSchema} from '../../../../api/DBSchema/Server';
import {dateToString, dateAndTimeToString, hasValue} from '../../../../utils/utils';
import Sepperator from '../../../../components/Simple/Sepperator';
import SMCButton from '../../../../components/Simple/SMCButton';
import SMCLabel from '../../../../components/Simple/SMCLabel';

const pageSchema = ServerGetSchema.pages.general;
const pageId = pageSchema.pageId;

function ServerGeneral({
    serverObject,
    reloadButtonOnClick
}) {
    const { t } = useTranslation();

    const pageData = serverObject[pageId];

    const serverName         = pageData[pageSchema.serverName];
    const serverOS           = pageData[pageSchema.serverOS];
    const numOfCPUs          = pageData[pageSchema.numOfCPUs];
    const lastMonitorSample  = pageData[pageSchema.lastMonitorSample];
    const virtualMemory      = pageData[pageSchema.virtualMemory];
    const totalServerCpu     = pageData[pageSchema.totalServerCpu];
    const diskSpace          = pageData[pageSchema.diskSpace];
    const isCertExpNoCa      = pageData[pageSchema.isCertExpNoCa];
    const isCertificateError = pageData[pageSchema.isCertificateError];
    const notAfter           = pageData[pageSchema.notAfter];
    const createTime         = pageData[pageSchema.createTime];
    const lastTime           = pageData[pageSchema.lastTime];
    
    return (
        <EditorLayout>
            <SMCTextInput
                readOnly
                value={serverName}
                label={t('SMP.SMP_SERVERS.PAGE.SERVER_NAME')}
            />
            <SMCTextInput
                readOnly
                value={serverOS}
                label={t('SMP.SMP_SERVERS.PAGE.SERVER_OS')}
            />
            <SMCTextInput
                readOnly
                value={numOfCPUs}
                label={t('SMP.SMP_SERVERS.PAGE.SERVER_NUM_OF_CPUS')}
            />
            <Sepperator />
            <SMCTextInput
                readOnly
                value={dateAndTimeToString(lastMonitorSample, true)}
                label={t('SMP.SMP_SERVERS.PAGE.LAST_MON_SAMP')}
            />
            <SMCTextInput
                readOnly
                value={virtualMemory}
                label={t('SMP.SMP_SERVERS.PAGE.VIRTUAL_MEM')}
            />
            <SMCTextInput
                readOnly
                value={totalServerCpu}
                label={t('SMP.SMP_SERVERS.PAGE.SEVER_CPU')}
            />
            <SMCTextInput
                readOnly
                value={diskSpace}
                label={t('SMP.SMP_SERVERS.PAGE.DISK_SPACE')}
            />
            <Sepperator />
            {
                isCertExpNoCa && (
                    <SMCLabel style={{ color: 'red' }}>{t('SMP.SMP_SERVERS.PAGE.CERT_AUTH_UNINITIALIZED')}</SMCLabel>
                )
            }
            {
                isCertificateError && (
                    <SMCLabel style={{ color: 'red' }}>{t('SMP.SMP_SERVERS.PAGE.CERT_NOT_AVAIL')}</SMCLabel>
                )
            }
            {
                hasValue(notAfter) && (
                    <SMCTextInput
                        readOnly
                        value={dateToString(notAfter)}
                        label={t('SMP.SMP_SERVERS.PAGE.CERT_EXPIRE_ON')}
                    />
                )
            }
            <Sepperator />
            <SMCTextInput
                readOnly
                value={dateAndTimeToString(createTime, true)}
                label={t('SMP.SMP_SERVERS.PAGE.CERT_NOT_AVAIL')}
            />
            <SMCTextInput
                readOnly
                value={dateAndTimeToString(lastTime, true)}
                label={t('SMP.SMP_SERVERS.PAGE.LAST_MODIFIED')}
            />
            <Sepperator />
            <SMCButton onClick={reloadButtonOnClick} ignoreDisabledContext>{t('SMC_SERVERS_REFRESH_SRV')}</SMCButton>

        </EditorLayout>
    )
}

export default ServerGeneral;